import CalendarView from './_CalendarView';

export default CalendarView;
